import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useAuth } from 'components/AuthProvider';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

export const LogoutBtn = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onClick = () => setIsOpen(true);

  const onCancel = () => setIsOpen(false);

  return (
    <>
      <Tooltip title="ログアウト">
        <IconButton onClick={onClick}>
          <ExitToAppIcon />
        </IconButton>
      </Tooltip>
      <LogoutDialog isOpen={isOpen} onCancel={onCancel} />
    </>
  );
};

interface LogoutDialogProps {
  isOpen: boolean;
  onCancel: () => void;
}

export const LogoutDialog = (props: LogoutDialogProps) => {
  const auth = useAuth();

  const onConfirmClick = () => auth.logout();

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={props.isOpen}
      closeAfterTransition
      onClose={props.onCancel}
    >
      <DialogTitle id="confirmation-dialog-title">
        ログアウトしますか？
      </DialogTitle>
      <DialogActions>
        <Button autoFocus onClick={props.onCancel}>
          キャンセル
        </Button>
        <Button
          onClick={onConfirmClick}
          variant="contained"
          color="primary"
          startIcon={<ExitToAppIcon />}
        >
          ログアウト
        </Button>
      </DialogActions>
    </Dialog>
  );
};
